"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContractConnect = void 0;

var _react = require("react");

var _types = require("../types");

var _system = require("@ethers-react/system");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* --- Effect --- */
var useContractConnect = (state, dispatch) => {
  var [, set] = (0, _react.useState)();
  /* --- Error : State --- */

  var [error, setError] = (0, _react.useState)();
  /* --- Initialize --- */

  var init = () => {};
  /* --- Sign Message :: Effect --- */


  (0, _react.useEffect)(() => {
    if (state.contracts && state.wallet) {
      var runEffect =
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(function* () {
          try {
            Object.keys(state.contracts).filter(contractId => {
              return state.contracts[contractId].address;
            }).forEach(contractId => {
              var contract = new _system.ethers.Contract(state.contracts[contractId].address, state.contracts[contractId].abi, state.wallet);
              dispatch({
                payload: contract,
                id: state.contracts[contractId].address,
                type: _types.CONTRACT_INITIALIZE_SUCCESS
              });
            });
          } catch (error) {
            console.log(error);
            setError(error);
          }
        });

        return function runEffect() {
          return _ref.apply(this, arguments);
        };
      }();

      runEffect();
    }
  }, [state.wallet]);
  /* --- Return : Complete --- */

  return {
    init,
    error: error
  };
};

exports.useContractConnect = useContractConnect;